import React, { useState } from "react";
import { Button, Menu, MenuItem, FormControlLabel, Radio, RadioGroup, IconButton, Tooltip, } from "@material-ui/core";
import { Settings } from "@material-ui/icons";
const DASHBOARD_TYPE_PARAM_NAME = "type";
export const DashboardSettings = ({ navigate, params, dashboards, }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleChange = (event) => {
        navigate(Object.assign(Object.assign({}, params), { [DASHBOARD_TYPE_PARAM_NAME]: encodeURIComponent(event.currentTarget.value), page: undefined }));
    };
    const handleClear = () => {
        navigate(Object.assign(Object.assign({}, params), { [DASHBOARD_TYPE_PARAM_NAME]: undefined, page: undefined }));
    };
    return (React.createElement("span", null,
        React.createElement(Tooltip, { title: "Dashboard settings" },
            React.createElement(IconButton, { size: "medium", onClick: handleMenuOpen, "data-test": "dashboard-settings", "aria-controls": "dashboard-filter", "aria-haspopup": "true", color: "primary" },
                React.createElement(Settings, null))),
        React.createElement(Menu, { getContentAnchorEl: null, anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "center",
            }, id: "case-type-filter", anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleMenuClose, className: "UserMenu" },
            React.createElement(RadioGroup, { "aria-label": "case-type", name: "case-type", value: params[DASHBOARD_TYPE_PARAM_NAME]
                    ? decodeURIComponent(params[DASHBOARD_TYPE_PARAM_NAME])
                    : "Default", onChange: handleChange }, dashboards.map((item) => {
                return (React.createElement(MenuItem, { key: item.id },
                    React.createElement(FormControlLabel, { value: item.id, control: React.createElement(Radio, null), label: item.name, "data-test": `dashboard-filter-case-type-${item.id}` })));
            })),
            React.createElement(MenuItem, null,
                React.createElement(Button, { variant: "text", onClick: handleClear, "data-test": "dashboard-filter-case-type-clear", fullWidth: true }, "Clear")))));
};
